const userLoginType = {
    DIRECT : 0,

    SINGLE_SIGN_ON : 1

};

angular.module('gw-um-j2js')
    .constant('userLoginType', userLoginType);